import React, {useEffect, useState} from 'react';
import Header from "../../common/Header";
//路由
import {useHistory} from "react-router-dom";
export default function Iframe (props) {
    let history = useHistory();
    const [iframeHeight, setIframeHeight] = useState(0);
    const [url, setUrl] = useState(null);
    useEffect(() => {

        console.log("props",props);
        if(props.match.params.url === 'lotteryPage'){
            const token = localStorage.getItem('token');
            const myUrl = 'https://www.jlszhgh.com';
            setUrl(myUrl+'/lotteryPage?authorization=' + token+'&laId=ff8080817cef1d8a017cef288d260006');
        }else{
            setUrl(props.match.params.url);
        }

    },[])

    return (
        <div>
            <div>
                <Header history={history} />
            </div>
            {
                url&&
                <iframe   scrolling="yes" frameBorder="0"
                              style={{width:'100%',height:iframeHeight, overflow:'visible'}}
                              onLoad={() => {//iframe高度不超过content的高度即可
                                  let h = document.documentElement.clientHeight - 20;
                                  setIframeHeight(h + 'px') ;
                              }}
                              src={url}
                />
            }

        </div>
    )
}
